export default __webpack_public_path__ + "static/media/person-stressed-out-by-technology.2b33ac52.png";